import { useCallback, useEffect } from 'react';

import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import { useGetLearnosityPlacementUrl } from '../../hooks/use-get-learnosity-placement-url';
import { ErrorPage } from '../Error/Error';

enum MessageType {
  TEST_SUBMITTED = 'TEST_SUBMITTED',
}

export const PlacementTestPlayerPage: React.FC = () => {
  const { lernosityUrl, isFetching, isError } = useGetLearnosityPlacementUrl();

  const handler = useCallback((event: MessageEvent) => {
    const type = event.data?.type;
    if (type === MessageType.TEST_SUBMITTED) {
      const redirectTo = event.data?.redirectTo;
      window.location.href = redirectTo;
    }
  }, []);

  const listen = useCallback(() => {
    window.addEventListener('message', handler);
  }, [handler]);

  const stopListening = useCallback(() => {
    window.removeEventListener('message', handler);
  }, [handler]);

  useEffect(() => {
    listen();

    return () => {
      stopListening();
    };
  }, []);

  if (isError) {
    return <ErrorPage />;
  }

  return (
    <div className="oejr-page-end-of-level-test">
      <DefaultHeader />
      {isFetching ? (
        <LoadingContainer />
      ) : (
        <iframe title="Placement Test Player" id="placement-test-player" src={lernosityUrl} />
      )}
    </div>
  );
};
